/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import ImageExample from '../examples/Image';
const ImageExampleSource = require('!!raw-loader!../examples/Image');
import ImageWithOverlayExample from '../examples/ImageWithOverlay';
const ImageWithOverlayExampleSource = require('!!raw-loader!../examples/ImageWithOverlay');
import RoundedImageExample from '../examples/RoundedImage';
const RoundedImageExampleSource = require('!!raw-loader!../examples/RoundedImage');
import RoundedImageWithCircleExample from '../examples/RoundedImageWithCircle';
const RoundedImageWithCircleExampleSource = require('!!raw-loader!../examples/RoundedImageWithCircle');
export default function ImagePage() {
    return (<div>
            <Helmet title="Image"/>
            <h3>Image</h3>
            <div className="docs-example">
                <ImageExample />
            </div>
            <pre>
                <PrismCode className="language-jsx">{ImageExampleSource}</PrismCode>
            </pre>

            <Helmet title="Image with overlay composition"/>
            <h3>Image with overlay composition</h3>
            <p>Image overlay creates a layer above the image where any element can be placed in each corner.</p>
            <div className="docs-example">
                <ImageWithOverlayExample />
            </div>
            <pre>
                <PrismCode className="language-jsx">{ImageWithOverlayExampleSource}</PrismCode>
            </pre>

            <Helmet title="Rounded Image"/>
            <h3>RoundedImage</h3>
            <div className="docs-example">
                <RoundedImageExample />
            </div>
            <pre>
                <PrismCode className="language-jsx">{RoundedImageExampleSource}</PrismCode>
            </pre>

            <h3>RoundedImage with circle around</h3>
            <div className="docs-example">
                <RoundedImageWithCircleExample />
            </div>
            <pre>
                <PrismCode className="language-jsx">{RoundedImageWithCircleExampleSource}</PrismCode>
            </pre>
        </div>);
}
